import Progress from './Progress';


Progress.install = function(Vue) {
  Vue.component(Progress.name, Progress);
};

export default Progress;
